import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Typography,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";

const { Option } = Select;
const { Title } = Typography;

const TransactionForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [owners, setOwners] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [passengers, setPassengers] = useState([]);

  useEffect(() => {
    fetchDropdownData();

    if (formData) {
      form.setFieldsValue({
        ...formData,
        startDate: formData.startDate ? moment(formData.startDate) : null,
        endDate: formData.endDate ? moment(formData.endDate) : null,
      });
    }
  }, [formData]);

  const fetchDropdownData = async () => {
    try {
      const [ownersResponse, vehiclesResponse, passengersResponse] = await Promise.all([
        axios.get("http://93.127.203.113:5005/owners"),
        axios.get("http://93.127.203.113:5005/vehicles"),
        axios.get("http://93.127.203.113:5005/passengers"),
      ]);

      setOwners(ownersResponse.data);
      setVehicles(vehiclesResponse.data);
      setPassengers(passengersResponse.data);
    } catch (error) {
      message.error("Failed to fetch dropdown data.");
    }
  };

  const onFinish = async (values) => {
    const isEdit = !!formData.transactionId;
    const apiUrl = isEdit
      ? `http://93.127.203.113:5005/transactions/${formData.transactionId}`
      : "http://93.127.203.113:5005/transactions";

    try {
      const payload = {
        ...values,
        startDate: values.startDate ? values.startDate.format("YYYY-MM-DD") : null,
        endDate: values.endDate ? values.endDate.format("YYYY-MM-DD") : null,
      };

      const request = isEdit
        ? axios.put(apiUrl, payload)
        : axios.post(apiUrl, payload);

      await request;

      message.success(`Transaction ${isEdit ? "updated" : "created"} successfully`);
      form.resetFields();
      closeModal();
      refetchData();
    } catch (error) {
      console.error("Error:", error);
      message.error(`Failed to ${isEdit ? "update" : "create"} transaction`);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData.transactionId ? "Edit Transaction" : "Add Transaction"}
      </Title>
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        style={{
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          padding: "20px",
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Owner"
              name="ownerId"
              rules={[{ required: true, message: "Please select an owner" }]}
            >
              <Select placeholder="Select an owner">
                {owners.map((owner) => (
                  <Option key={owner.id} value={owner.id}>
                    {owner.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Vehicle"
              name="vehicleId"
              rules={[{ required: true, message: "Please select a vehicle" }]}
            >
              <Select placeholder="Select a vehicle">
                {vehicles.map((vehicle) => (
                  <Option key={vehicle.id} value={vehicle.id}>
                    {vehicle.plateNumber}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Passenger" name="passengerId">
              <Select placeholder="Select a passenger (optional)">
                {passengers.map((passenger) => (
                  <Option key={passenger.id} value={passenger.id}>
                    {`${passenger.firstName} ${passenger.lastName}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Price Per Day"
              name="pricePerDay"
              rules={[{ required: true, message: "Please enter price per day" }]}
            >
              <Input type="number" placeholder="Enter price per day" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Start Date"
              name="startDate"
              rules={[{ required: true, message: "Please select start date" }]}
            >
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="End Date" name="endDate">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Working Days"
              name="workingDays"
              rules={[{ required: true, message: "Please enter working days" }]}
            >
              <Input type="number" placeholder="Enter working days" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Days Not Worked" name="daysNotWorked">
              <Input type="number" placeholder="Enter days not worked" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="To Be Paid To Owner" name="toBePaidToOwner">
              <Input type="number" placeholder="Amount to be paid to owner" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="VAT" name="VAT">
              <Input type="number" placeholder="Enter VAT amount" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Withholding" name="withholding">
              <Input type="number" placeholder="Enter withholding amount" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Net Collected" name="netCollected">
              <Input type="number" placeholder="Enter net collected amount" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Profit" name="profit">
              <Input type="number" placeholder="Enter profit amount" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Commission" name="commission">
              <Input type="number" placeholder="Enter commission amount" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            onClick={() => form.resetFields()}
            style={{ marginLeft: "10px", borderColor: "#0c8c49", color: "#0c8c49" }}
          >
            Reset
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default TransactionForm;
